/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import { hmsAPI } from '@/api'

export const getRaceImages = (raceId, params) => hmsAPI.get(`/raceimages/${raceId}`, { params })
export const getRaceImagesFilters = (raceId, params) => hmsAPI.get(`/raceimages/${raceId}/filters`, { params })
export const getRaceFavoritesImagesFilters = (raceId, params) => hmsAPI.get(`/raceimages/${raceId}/favorites/filters`, { params })
export const getFavoritesRaceImages = (raceId, params) => hmsAPI.get(`/raceimages/${raceId}/favorites`, { params })
export const putFavoritesRaceImages =  images => hmsAPI.put(`/favorites`, images)
export const postFavoritesRaceImages =  images => hmsAPI.post(`/favorites`, images)
export const deleteFavoritesRaceImages =  params => hmsAPI.delete(`/favorites`, { params })
